import React from "react";
import { useStyles } from "../ScoreboardStyles.css";
import GameSessionScore from "../../scoreboard-content/scores/GameSessionScore";
import SessionInfo from "../../scoreboard-content/info/SessionInfo";
import { motion } from "framer-motion";
const ScoreboardTopPoints = ({
    discipline,
    association,
    ageGroup,
    gender,
    scores,
    penaltyRed,
    penaltyBlue,
    athleteLeftPosition,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.scoreboardContainer}>
            <motion.div animate={{ scale: [1, 1.5, 1.5, 1, 1] }}>
                <GameSessionScore
                    className={classes.scoresLeft}
                    pointScore={
                        athleteLeftPosition === "red"
                            ? scores.scoreRedPlayer
                            : scores.scoreBluePlayer
                    }
                    penaltyScores={
                        athleteLeftPosition === "red" ? penaltyRed : penaltyBlue
                    }
                    color={athleteLeftPosition === "red" ? "red" : "blue"}
                    position={"left"}
                />
            </motion.div>
            <SessionInfo
                className={classes.sessioninfo}
                association={association}
                ageGroup={ageGroup}
                gender={gender}
                discipline={discipline}
            />
            <GameSessionScore
                className={classes.scoresRight}
                pointScore={
                    athleteLeftPosition === "red"
                        ? scores.scoreBluePlayer
                        : scores.scoreRedPlayer
                }
                penaltyScores={athleteLeftPosition === "red" ? penaltyBlue : penaltyRed}
                color={athleteLeftPosition === "red" ? "blue" : "red"}
                position={"right"}
            />
        </div>
    );
};

export default ScoreboardTopPoints;
